import { Link } from '@/i18n/routing';
import { cn } from '@/utils/cn';

interface Props {
  variant: 'button' | 'link';
  href: string;
  disabled?: boolean;
  onClick?: () => void;
  className: string;
  children: React.ReactNode;
  ariaLabel?: string;
  ariaCurrent?: 'page';
}
export const PaginationItem = ({ variant, href, disabled, onClick, className, children, ariaLabel, ariaCurrent }: Props) => {
  if (variant === 'button') {
    return (
      <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        aria-label={ariaLabel}
        aria-current={ariaCurrent}
        className={className}
      >
        {children}
      </button>
    );
  }

  if (disabled) {
    return (
      <span
        aria-label={ariaLabel}
        aria-current={ariaCurrent}
        aria-disabled="true"
        className={cn(className, 'pointer-events-none')}
      >
        {children}
      </span>
    );
  }

  return (
    <Link
      prefetch={false}
      href={href}
      aria-label={ariaLabel}
      aria-current={ariaCurrent}
      className={className}
    >
      {children}
    </Link>
  );
};

export default PaginationItem;
